<template>
    <div class="listado-neumaticos">
        <div v-if="loading">
            <div class="loading">
                <div class="lds-ring">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <!--filtro listado neumaticos -->
        <div class="col-12">
          <div class="col-12 texto filtro-rapido" style="text-align: right;"><a id="boton-filtro-neumaticos" class="boton-filtro-neumaticos"><i class="fas fa-filter"></i>FILTROS</a></div>
        </div>
                <div v-show="buscadorpaso1" class="col-md-3 col-sm-12 col-12 row vehiculo" style="position:relative;float:left;">

                    <br /><br />
                    <div class="col-12 encabezado-neu">
                    <p class="titulo_oculto">¿Qué neumáticos necesitas?</p>
                    <div class="col-12" style="">

                      <!-- <div class="col-12" >
                          <div class="col-md-3 col-sm-1" style="float:left">
                            <p>&nbsp;</p>
                          </div>
                          <div class="col-md-6 col-sm-10" style="float:left;">
                            <p>&nbsp;</p>
                          </div>
                          <div class="col-md-3 col-sm-1" style="float:left;z-index:199;left:0px;top:15px;">
                                <div class="col-md-2 dvpaso1_ocultar" style="float:left;">
                                  <p>&nbsp;</p>
                                </div>
                                <div class="col-md-10" style="float:left;">
                                    <a href="#" @click="[buscadorpaso2 = true, buscadorpaso1 = false]" class="continuar_neu"><img src="../images/iconos/Dark/ok.png" style="float:left;" /></a>
                                </div>
                                <div class="col-md-2 dvpaso1_mostrar" style="float:left; display:none;">
                                  <p>&nbsp;</p>
                                </div>
                          </div>
                      </div> -->
                       <div class="col-12" style="position:absolute;float:left;top:10px;left:10px">

                    <div class="col-12 centrar" style="float:left;margin-left:0px;padding-left:0px;padding-right:0px;">
                        <div class="col-12" style="text-align:left;margin-top:10px;float:left;">
                          <label class="lbel-buscador">Vehículo</label><br/>
                           <select v-model="request_filters.filters.tipo_vehiculo" class="selects_en">
                              <option value="0" selected="selected">&nbsp;</option>
                              <option v-for="(item,key) in tipovehiculos" v-bind:key="key" v-bind:value="item.vehicle_type">{{ item.name }}</option>
                              <!-- <option v-for="tp in tipovehiculos" v-bind:value="tp.vehicle_type">
                                  {{tp.name}}</option> -->
                          </select>
                        </div>
                        <div class="col-12" style="margin-top:10px;text-align:left;float:left;">
                          <label class="lbel-buscador">Estación</label><br/>
                          <select name="estacion" v-model="request_filters.filters.estacion"
                              class="selects_en">
                              <option value='0' selected="selected">Estación</option>
                              <!-- <option v-for="estacion in estaciones" v-bind:value="estacion.season">{{estacion.name}}</option> -->
                              <option v-for="(item,key) in estaciones"  v-bind:key="key" v-bind:value="item.season">{{item.name}}</option>
                          </select>
                        </div>
                        <div class="col-12" style="margin-top:10px;text-align:left;float:left;">
                          <label class="lbel-buscador">Marca</label><br/>
                         <select name="marca" v-model="request_filters.filters.marca" required="true"
                              class="selects_en">
                              <option value="0">Todas marcas</option>
                              <!-- <option v-for="marca in marcas" v-bind:value="marca.brand">{{marca.brand}}</option> -->
                              <option v-for="(item,key) in marcas" v-bind:key="key" v-bind:value="item.brand">{{item.brand}}</option>
                          </select>
                        </div>
                          <div class="col-12" style="margin-top:15px;float:left;text-align:left;">
                          <input type="checkbox" id="antipichazos" v-model="request_filters.filters.runflat"
                                  true-value="Y" false-value="N">
                              <label class="lbel-buscador" for="antipichazos" id="antipichazos" style="display:inline">Antipinchazos</label><br/>
                              <input type="checkbox" id="reforzados" v-model="request_filters.filters.reforzada"
                                  true-value="Y" false-value="N">
                              <label for="reforzados" id="reforzados" class="lbel-buscador" style="display:inline">Reforzados</label>
                          </div>

                        <!-- <div class="col-12 encabezado-neu2-abajo" style="position: absolute; display: inline-block; text-align: center; height: 80px;"> -->
                            <!-- <div class="col-12" style="position:absolute;top:20px;left:25px;text-align:left;">
                                <div class="col-md-2 col-sm-1 col-1" style="float:left;z-index:199;">
                                    <a href="#" @click="[buscadorpaso2 = false, buscadorpaso1 = true]" class="buscar_neu" >
                                      <img src="../images/iconos/Dark/prev.png" style="float:right"/>
                                    </a>
                                </div>
                              <div class="col-md-8 col-sm-10 col-9 centrar" style="float:left">
                                <p>&nbsp;</p>
                              </div>
                              <div class="col-md-2 col-sm-1 col-1" style="float:left;left:-25px;z-index:199;">
                                  <a href="#" @click="request_filters.page=1,getNeumaticos()" class="continuar_neu"><img src="../images/iconos/Dark/ok.png" style="float:left" /></a>
                              </div>
                          </div> -->
                          <!-- <div class="col-12" style="top:25%;">
                              <p>&nbsp;</p>
                          </div> -->

                              <div class="col-12" style="margin-top:15px;float:left;text-align:left;">
                                      <label class="lbel-buscador">Anchura</label><br/>
                                    <select v-model="request_filters.filters.ancho" class="selects_en" >
                                        <option value="0">Todas</option>
                                        <!-- <option v-for="ancho in anchuras" v-bind:value="ancho.width">{{ancho.width}}</option> -->
                                        <option v-for="(item,key) in anchuras" v-bind:key="key" v-bind:value="item.width">{{item.width}}</option>
                                    </select>
                              </div>
                                <div class="col-12" style="float:left;text-align:left;">
                                    <!-- <label><strong>Perfil</strong><a href=""><i class="fas fa-question-circle"><p>205/<b style="color:#ffca36;">55</b>-17R TL</p></i></a></label><br /> -->
                                    <!-- <select v-model="request_filters.filters.alto" class="selects_en" >
                                        <option value="0" selected="selected">Perfil</option>
                                        <option v-for="alto in alturas" v-bind:value="alto.profile" v-if="alto.profile!=''">{{alto.profile}}</option>
                                    </select> -->
                                    <label class="lbel-buscador">Perfil</label><br/>
                                    <select v-model="request_filters.filters.alto" class="selects_en">
                                        <option value="0">Todos</option>
                                        <!-- <option v-for="alto in alturas" v-bind:value="alto.profile" v-if="alto.profile!=''">{{alto.profile}} </option> -->
                                        <option v-for="(alto,key) in alturas" v-bind:key="key" v-bind:value="alto.profile" v-if="alto.profile!=''">{{alto.profile}} </option>
                                    </select>
                                </div>
                                <div class="col-12" style="float:left;text-align:left;">
                                    <label class="lbel-buscador">Diametro</label><br/>
                                    <select v-model="request_filters.filters.diametro" class="selects_en">
                                        <option value="0">Todos</option>
                                        <!-- <option v-for="diametro in diametros" v-bind:value="diametro.diameter"> {{diametro.diameter}}</option> -->
                                        <option v-for="(diametro,key) in diametros" v-bind:key="key" v-bind:value="diametro.diameter"> {{diametro.diameter}}</option>
                                    </select>
                                </div>
                                <div class="col-12" style="float:left;text-align:left;">
                                  <label class="lbel-buscador">Carga</label><br/>
                                    <select v-model="request_filters.filters.carga" class="selects_en">
                                        <option value="0">Todas</option>
                                        <!-- <option v-for="carga in cargas" v-bind:value="carga.load_rating">{{carga.load_rating}} -->
                                        <option v-for="(carga,key) in cargas" v-bind:key="key" v-bind:value="carga.load_rating">{{carga.load_rating}}
                                        </option>
                                    </select>
                                </div>
                                <div class="col-12" style="float:left;text-align:left;">
                                    <label class="lbel-buscador">Velocidad</label><br/>
                                   <select v-model="request_filters.filters.velocidad" class="selects_en">
                                        <option value="0">Todas</option>
                                        <!-- <option v-for="velocidad in velocidades" v-bind:value="velocidad.speed_rating">{{velocidad.speed_rating}}</option> -->
                                        <option v-for="(velocidad,key) in velocidades" v-bind:key="key" v-bind:value="velocidad.speed_rating">{{velocidad.speed_rating}}</option>
                                    </select>
                                </div>
                                <div class="col-sm-3" style="float:left;">
                                    <a href="#" @click="request_filters.page=1,getNeumaticos()" class="continuar_neu"><button class="form-control solicitar solicitarboton" style="width:100px;margin-top: 30px;font-size: 0.8em;">Buscar</button></a>
                                </div>
                            <div class="col-1" style="float:left">
                              <p>&nbsp;</p>
                            </div>

                            <div class="col-1" style="float:left;">
                               <p>&nbsp;</p>
                            </div>

                            <span class="detalle-separador"></span>
                      </div>

                    </div>
                    </div>
                  </div>
                </div>
              <!-- </div> -->

                   <!-- <div v-show="buscadorpaso3" class="row anchura">
                    <br /><br />
                    <div class="col-12 encabezado-neu3" style='background-image: url("/images/servicios/neumaticos/cabecerapaso3final.jpg");'>
                      <p class="titulo_oculto">¿Son correctas estas medidas?</p>
                      <div class="col-12 encabezado-neu3-abajo" style="position: absolute; display: inline-block; text-align: center; height: 80px;">
                          <div class="col-12" style="position:absolute;top:10px;z-index:199;left:25px;text-align:left;">
                              <div class="col-md-2 col-sm-1 col-1" style="float:left;">

                                <div class="col-md-2 col-sm-1 col-1" >
                                    <a href="#" @click="[buscadorpaso3 = false, buscadorpaso2 = true]" class="buscar_neu">
                                    <img src="/images/iconos/Dark/prev.png" style="z-index:199;"/>
                                  </a>
                                </div>
                              </div>
                              <div class="col-md-8 col-sm-10 col-9" style="float:left;">
                                <p>&nbsp;</p>
                              </div>
                              <div class="col-md-2 col-sm-1 col-1 centrar" style="float:left;left:-25px;">

                                <div class="continuar_neu">
                                    <a href="#" @click="getNeumaticos()" class="buscar_neu">
                                    <img src="/images/iconos/Dark/ok.png" style="float:right;"/>
                                  </a>
                                </div>
                              </div>
                          </div>
                          <div class="col-12" style="position: absolute; top: 10px; left: 25px; text-align: left;">
                              <div class="col-xl-12 col-lg-12col-md-12 col-sm-12 col-12" style="float:left">
                                  <p class="cabecera-medidas">{{request_filters.filters.ancho!=0? request_filters.filters.ancho: '_'}}/{{request_filters.filters.alto!=0?request_filters.filters.alto: '_'}} - {{request_filters.filters.diametro!=0?request_filters.filters.diametro: '_'}}R {{request_filters.filters.carga!=0?request_filters.filters.carga: '_'}}{{request_filters.filters.velocidad!=0?request_filters.filters.velocidad: '_'}}</p>
                              </div>
                              <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-6" style="float:left;text-align:right;">
                                  <a href="#" @click="getNeumaticos()" class="buscar_neu""><button
                                      type="button" class="btn btn-default btn-neumatico"><b>Aceptar</b></button></a>
                              </div>
                              <div class="col-2" style="float:left;text-align:left;">
                                  <a href="#" @click="[buscadorpaso3 = false, buscadorpaso2 = true]" class="buscar_neu""><button
                                      type="button" class="btn btn-default btn-neumatico"><b>Modificar</b></button></a>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div> -->

        <!-- Listado neumaticos -->

        <div class="container-full neumaticos-listado col-lg-9 col-md-9 col-sm-12" style="position:relative;float:left;">
            <div class="">

                <div class="col-12">

                    <div class="fusion-row">
                      <section id="content" style="width:100%">
                          <div class="fusion-layout-column fusion_builder_column fusion-builder-column-0 fusion_builder_column_1_1 1_1 fusion-flex-column renting_sombreado" v-for="(item,key) in list" v-bind:key="key" style="float:left;display:block;">
                            <div class="col-12 item-neumaticos">
                                <div class='col-md-5 col-sm-12 ofertas_imagen_principal' style='position:relative;float:left;text-align:center;'>
                                <img :src="item.draw" onerror="this.src='https://intranet.dsimobility.es/images/servicios/neumaticos/neumatico_perfil.png'" style="object-fit:cover;width:50%;height:100%;">
                              </div>
                              <div class="col-md-7 col-sm-12 neumaticos-sombreado" style="float:left;position:relative;padding-left:20px;padding-right:20px;">
                                <div class="col-sm-12" style="border-bottom:2px solid #ccc;padding:0px;height:70%;display: flex;align-items: center;position:relative;float:left;">
                                <div class="col-sm-10 col-12 neumaticos-titulo">
                                <a href="#"><h3><strong>{{item.brand}} {{item.model}}</strong></h3></a>
                                <h4>
                                    {{item.width}}/{{item.profile}} - {{item.diameter}}R {{item.load_rating}}{{item.speed_rating}}
                                </h4>
                                <p class="producto-descripcion"><a :href=" '/neumaticos/'+item.description.replace(/\s+/g,'-').replace('/','-').replace('/','-')+'/'+item.code_id">Ver descripción del producto</a></p>
                              </div>
                              <div class="col-sm-2">
                                &nbsp;
                              </div>
                            </div>
                              <div class="col-sm-12" style="display:flex;align-items:center;height:30%;position:relative;float:left;">
                              <div class="col-precio col-sm-8">
                                <p class="precio-neumatico">{{(((parseFloat(item.price_provider)+parseFloat(item.price_provider*margen))+(parseFloat(item.price_provider)+parseFloat(item.price_provider*margen))*0.21).toFixed(2)).replace(".",",")}}€ (IVA incluido) <br/></p>

                              </div>
                              <div class="col-precio col-sm-4" >
                                <a href="#" :id="key" data-toggle="modal" v-bind:data-target="'.modal-neumatico'" @click="[modalNeumaticoShow = item, setEstadistica(item.code_id,'ficha')]">
                                    <button class="boton-item-neumaticos"><i class="fb-icon-element-1 fb-icon-element fontawesome-icon fa-cart-plus fas circle-no fusion-text-flow" style="font-size:12px;color:#fff;"></i> Pide ya tus ruedas</button>
                                </a>
                              </div>
                            </div>
                              </div>
                            </div>
                            </div>
                            <!-- </div> -->
                          <!-- </div> -->
                        <div>&nbsp;</div>
                        <div class="col-12" style="text-align:center;">
                        <nav style="display:inline-block;width:100%;">
                            <ul class="pagination" style="width:100%;">
                              <span @click="getPage(current_page-1)">
                                <li v-if="current_page >1" class="page-link">
                                    <span aria-hidden="true">&lt; Anterior</span>
                                    <span class="sr-only">Previous</span>
                                </li>
                              </span>
                              <a rel="nofollow" href="#" @click="getPage(1)">
                                <li v-if="current_page >1" class="page-link">
                                    <span>1</span>

                                </li>
                              </a>
                              <li v-if="current_page >3" class="disabled">
                                  <span class="page-link">...</span>
                              </li>
                              <li v-if="current_page >2" class="page-link">
                                <span @click="getPage(current_page-1)">
                                      <span>{{current_page-1}}</span>
                                </span>
                              </li>
                              <li v-if="current_page < 2" class="active">
                                  <span href="#" class="page-link">

                                    <span>{{current_page}}</span>
                                 </span>
                               </li>
                               <li v-if="current_page >1" class="active">
                                   <span class="page-link">

                                     <span>{{current_page}}</span>
                                  </span>
                                </li>
                              <span @click="getPage(current_page+1)">
                                <li v-if="current_page < last_page" class="page-link">
                                    <span>{{current_page+1}}</span>
                                </li>
                              </span>
                              <li v-if="current_page < last_page-2" class="disabled">
                                  <span class="page-link">...</span>
                              </li>
                              <span @click="getPage(last_page)">
                                <li v-if="current_page < last_page-1" class="page-link">
                                    <span>{{last_page}}</span>
                                </li>
                              </span>
                              <span @click="getPage(current_page+1)">
                                <li v-if="current_page < last_page" class="page-link">
                                    <span aria-hidden="true">Siguiente &gt;</span>
                                    <span class="sr-only">Next</span>
                                </li>
                              </span>
                          </ul>

                        </nav>
                      </div>
                    </section>
                   </div>
                </div>
            </div>
        </div>
        <!-- Abrimos Modal para seleccionar la cantidad de neumaticos que queremos -->
        <div v-show="modalNeumaticoShow">
                            <div :class="'modal fade modal-neumatico'" tabindex="-1" role="dialog">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal"
                                                aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        </div>
                                        <div class="modal-body form-neumatico">
                                            <form name="seleccionarunidades">
                                                <h4 class="modal-title text-center"><b>{{modalNeumaticoShow.brand}}
                                                        {{modalNeumaticoShow.model}}</b></h4>
                                                <p class="text-center">
                                                    <font color="#7993fc">{{modalNeumaticoShow.width}}/{{modalNeumaticoShow.profile}} - {{modalNeumaticoShow.diameter}}R {{modalNeumaticoShow.load_rating}}{{modalNeumaticoShow.speed_rating}}</font>
                                                </p>
                                                <div class="btn-toolbar neumatico-info2" role="toolbar">
                                                    <div class="btn-group">
                                                        <input type="button" class="btn btn-default"
                                                            v-on:click="getUnidades(1,modalNeumaticoShow.price_provider,modalNeumaticoShow.code_id,modalNeumaticoShow.width+'/'+modalNeumaticoShow.profile+' - '+modalNeumaticoShow.diameter+'R '+modalNeumaticoShow.load_rating+modalNeumaticoShow.speed_rating,modalNeumaticoShow.brand,modalNeumaticoShow.model,modalNeumaticoShow.ecotax,modalNeumaticoShow.diameter)" value="1 rueda">
                                                    </div>
                                                    <div class="btn-group">
                                                        <input type="button" class="btn btn-default"
                                                            v-on:click="getUnidades(2,modalNeumaticoShow.price_provider,modalNeumaticoShow.code_id,modalNeumaticoShow.width+'/'+modalNeumaticoShow.profile+' - '+modalNeumaticoShow.diameter+'R '+modalNeumaticoShow.load_rating+modalNeumaticoShow.speed_rating,modalNeumaticoShow.brand,modalNeumaticoShow.model,modalNeumaticoShow.ecotax,modalNeumaticoShow.diameter)" value="2 ruedas">
                                                    </div>
                                                    <div class="btn-group">
                                                        <input type="button" class="btn btn-default"
                                                            v-on:click="getUnidades(3,modalNeumaticoShow.price_provider,modalNeumaticoShow.code_id,modalNeumaticoShow.width+'/'+modalNeumaticoShow.profile+' - '+modalNeumaticoShow.diameter+'R '+modalNeumaticoShow.load_rating+modalNeumaticoShow.speed_rating,modalNeumaticoShow.brand,modalNeumaticoShow.model,modalNeumaticoShow.ecotax,modalNeumaticoShow.diameter)" value="3 ruedas">
                                                    </div>
                                                    <div class="btn-group">
                                                        <input type="button" class="btn btn-default"
                                                            v-on:click="getUnidades(4,modalNeumaticoShow.price_provider,modalNeumaticoShow.code_id,modalNeumaticoShow.width+'/'+modalNeumaticoShow.profile+' - '+modalNeumaticoShow.diameter+'R '+modalNeumaticoShow.load_rating+modalNeumaticoShow.speed_rating,modalNeumaticoShow.brand,modalNeumaticoShow.model,modalNeumaticoShow.ecotax,modalNeumaticoShow.diameter)" value="4 ruedas">
                                                    </div>
                                                </div>
                                                <img style="display:block;margin:40px auto;" :src="modalNeumaticoShow.draw" onerror="this.src='https://intranet.dsimobility.es/images/servicios/neumaticos/neumatico_perfil.png'"
                                                    width=200px height=auto>
                                                <div class="neumatico-info">
                                                    <div v-if="modalNeumaticoShow.season=='VERANO'" class="col-4 left">
                                                        <img src="../images/iconos/Dark/summer.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-else="" class="col-4 left">
                                                        <img src="../images/iconos/Light/summer.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-if="modalNeumaticoShow.season=='INVIERNO'" class="col-4 left">
                                                        <img src="../images/iconos/Dark/winter.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-else="" class="col-4 left">
                                                        <img src="../images/iconos/Light/winter.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-if="modalNeumaticoShow.season=='4ESTACIONES'" class="col-4 left2">
                                                        <img src="../images/iconos/Dark/allseason.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-else="" class="col-4 left2">
                                                        <img src="../images/iconos/Light/allseason.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                </div><br />
                                                <div class="neumatico-info">
                                                    <div v-if="modalNeumaticoShow.runflat=='Y'" class="col-4 left" >
                                                        <img src="../images/iconos/Dark/rf.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-else="" class="col-4 left">
                                                        <img src="../images/iconos/Light/rf.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-if="modalNeumaticoShow.reinforced=='Y'" class="col-4 left">
                                                        <img src="../images/iconos/Dark/bolster.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div v-else="" class="col-4 left">
                                                        <img src="../images/iconos/Light/bolster.png" style="width:64px;heigth:auto;">
                                                    </div>
                                                    <div class="col-4 left2">

                                                    </div>

                                                </div>
                                                <div class="neumatico-fondo">
                                                   <div class="col-md-6 col-sm-6 col-6" style="float:left;margin-top:30px;">
                                                    <div class="neumatico-info3">
                                                        <div class="neu-precio">{{((parseFloat(modalNeumaticoShow.price_provider)+parseFloat(modalNeumaticoShow.price_provider*margen))+(parseFloat(modalNeumaticoShow.price_provider)+parseFloat(modalNeumaticoShow.price_provider*margen))*0.21).toFixed(2).replace(".",",")}}€</div>
                                                    </div>
                                                    <div class="neumatico-info3">
                                                        <div ><span style="font-size:2em">por unidad</span><br/>
                                                            <span style="font-size:1em !important">(IVA incluido)</span></div>
                                                    </div>
                                                   </div>

                                                   <div class="col-md-2 col-sm-3 col-3" style="float:left;margin-top:10px;">

                                                      <div v-if="(modalNeumaticoShow.fuel_efficiency=='A' || modalNeumaticoShow.fuel_efficiency=='B' || modalNeumaticoShow.fuel_efficiency=='C' || modalNeumaticoShow.fuel_efficiency=='D')" class="neumatico-info3" sytle="align:right;">
                                                            <p style="background:#8afd17;width:50px;padding-left:15px;padding-top:15px;padding-bottom:15px;font-size:1.2em !important;"><b>{{modalNeumaticoShow.fuel_efficiency}}</b></p>
                                                      </div>
                                                      <div v-else-if="(modalNeumaticoShow.fuel_efficiency=='E' || modalNeumaticoShow.fuel_efficiency=='F' || modalNeumaticoShow.fuel_efficiency=='G' )" class="neumatico-info3" sytle="align:right;">
                                                            <p style="background:#fdad39;width:50px;padding-left:15px;padding-top:15px;padding-bottom:15px;font-size:1.2em !important;"><b>{{modalNeumaticoShow.fuel_efficiency}}</b></p>
                                                      </div>
                                                      <div class="neumatico-info3" sytle="align:right;">
                                                            <p style="background:#5cdbfc;width:50px;padding-left:15px;padding-top:15px;padding-bottom:15px;font-size:1.2em !important;"><b>{{modalNeumaticoShow.wet_grip}}</b></p>
                                                      </div>
                                                      <div class="neumatico-info3" sytle="align:right;">
                                                            <p style="background:#fdad39;width:50px;padding-left:2px;padding-top:15px;padding-bottom:15px;font-size:1.2em !important;"><b>{{modalNeumaticoShow.decibels}}dB</b></p>
                                                      </div>
                                                  </div>
                                                  <div class="col-md-4 col-sm-3 col-3" style="float:left;padding-top:-10px;">

                                                     <div style="width:70px;height:70px;align:left;">
                                                          <img  class="iconos" src="../images/servicios/neumaticos/resistencia.png" height="80px !important" style="margin-top:10px;"/>
                                                     </div>
                                                     <div style="width:auto;height:60px;align:left;">
                                                          <img class="iconos" src="../images/servicios/neumaticos/mojado.png" height="80px !important" style="margin-top:20px;"/>
                                                     </div>
                                                     <div style="width:auto;height:60px;align:left;">
                                                          <img class="iconos" src="../images/servicios/neumaticos/decibelios.png" width="80px !important" style="margin-top:20px;"/>
                                                     </div>
                                                 </div>
                                                    <div class="neumatico-info4">
                                                        <a href="#" :id="key" @click="[modalCompraShow = modalNeumaticoShow, modalCompraShow.unidades=unidades, getUnidades(unidades,modalNeumaticoShow.price_provider,modalNeumaticoShow.code_id,modalNeumaticoShow.width+'/'+modalNeumaticoShow.profile+' - '+modalNeumaticoShow.diameter+'R '+modalNeumaticoShow.load_rating+modalNeumaticoShow.speed_rating,modalNeumaticoShow.brand,modalNeumaticoShow.model,modalNeumaticoShow.ecotax,modalNeumaticoShow.diameter), modalCompraShow.preciototal=preciototal,modalNeumaticoShow=false, calcularPrecioTotal(montajeprice,1,modalNeumaticoShow.unidades), quitarClase(), setEstadistica(modalCompraShow.code_id,'compra') ]"
                                                              ><div class="boton-item-neumaticos">Pide ya tus ruedas</div></a>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                          </div>
                        </div>
    <!-- </div> -->
    <!-- Abrimos Modal para introducir los datos del usario, elegir taller,etc de neumaticos -->
      <div v-if="modalCompraShow">
         <!-- <form-wizard nextButtonText="Siguiente" ref="listadoNeumaticos" :title="title" subtitle="" color="#ffca36" errorColor="#c77878">  -->
         <div class="modal fade modal-compra show" tabindex="-1" role="dialog" style="display:block">
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h2>Tu compra</h2>
                <button type="button" class="close" @click="modalCompraClose(),modalCompraShow.montaje='',modalCompraShow.montajeprice=''" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <!-- <button type="button" class="close" @click="cerrarModal()" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
              </div>
              <form-wizard nextButtonText="Siguiente" backButtonText="Anterior" finishButtonText="Finalizar" ref="listadoNeumaticos" title="" subtitle="" color="#7993fc" errorColor="#c77878">
          <tab-content title="COMPRA" :before-change="CalculaStock">
            <div class="col-sm-12" style="min-height:150px;">
            <div class="col-md-1 col-sm-2 col-3" style="float:left"><img  :src="modalCompraShow.draw" onerror="this.src='https://intranet.dsimobility.es/images/servicios/neumaticos/neumatico_perfil.png'" width="50px !important"  height="50px !important"/></div>
            <div class="col-md-6 col-sm-10 col-9" style="float:left"> {{modalCompraShow.brand}} {{modalCompraShow.model}} {{modalCompraShow.width}}/{{modalCompraShow.profile}} - {{modalCompraShow.diameter}}R {{modalCompraShow.load_rating}}{{modalCompraShow.speed_rating}} </div>
            <div class="col-md-3 col-sm-6 col-6" style="float:left"><input  class="col-12" v-model="unidades" v-on:click="calcularPrecio(importenet)" type="number" name="unidades" min="1"> </div>
            <!-- <button v-on:click="decrementUnidades">-</button>{{ unidades }}
            <button v-on:click="incrementUnidades">+</button> -->
             <!-- <input type="text" v-model="preciototal" name="preciototal" v-on:input="calcularPrecio2(modalCompraShow.price*modalCompraShow.unidades)" class="col-2" >{{modalCompraShow.price}} € -->
            <div class="col-md-2 col-sm-4 col-5" style="float:left">{{parseFloat(preciototal).toFixed(2).replace(".",",")}} €<br/> <font size="0.9em">(Precio unitario {{parseFloat(importe).toFixed(2).replace(".",",")}} €)</font></div>
            </div>
            <br/>
            <div class="col-sm-12 sombreado" style="border-color:#dfdfdf;border:1px solid;border-radius:5px;padding-top:5px;margin-top:-16px;min-height:350px;">

            <div class="col-12 ecotasa"><div class="col-sm-10 col-10" style="float:left">+ Ecotasa (por neumático)</div> <div class="col-sm-2 col-2" style="float:left">{{modalCompraShow.ecotax.replace(".",",")}}€</div></div>
            <br/>
            <hr/>
            <div class="col-12 montaje" >
                <div class="col-sm-10 col-10" style="float:left">
                  <input type="checkbox" @click="calcularPrecioTotal(montajeprice,1,modalCompraShow.unidades)" name="montaje" id="montaje" value="modalCompraShow.montaje" checked><label for="montaje" style="margin-left:7px;">Montaje+equilibrado+válvula neumático turismo (por neumático)</label>
                  <p style="margin-top:-10px;margin-left:20px;">(Válvula electrónica no incluida)</p>
                </div>
                <div class="col-sm-2 col-2" style="float:left">
                    {{parseFloat(montajeprice).toFixed(2).replace(".",",") }}€
                </div>
            </div>
           <hr/>
           <!-- <div class="col-12">
                <div class="col-10">
                  <input type="checkbox"@click="calcularPrecioTotal(36,2)" name="seguridad" id="seguridad" value="36"><label for="montaje">Pack seguridad: montaje+equilibrado+válvula (excluidas las electrónicas)+ nitrógeno+garantía antipinchazos </label>
                </div>
                <div class="col-2">
                    36,00 €
                </div>
            </div>
            <hr/> -->
            <div class="col-12">
                <div class="col-10" style="float:left">
                  <input type="checkbox" @click="calcularPrecioTotal(alineacionprice,3,modalCompraShow.unidades)" name="alineacion" id="alineacion" value="42"><label for="alineacion" style="margin-left:7px;">Alineación de dirección turismo </label>
                </div>
                <div class="col-2" style="float:left">
                    {{parseFloat(alineacionprice).toFixed(2).replace(".",",") }}€
                </div>
            </div>
            <br/>
            <hr/>
            <div class="col-12">
                <div class="col-10" style="float:left">
                  <input type="checkbox" @click="calcularPrecioTotal(permutacionprice,4,modalCompraShow.unidades)" name="neumaticos" id="neumaticos" value="10"><label for="permutacion" style="margin-left:7px;">Permutación de neumáticos turismo </label>
                </div>
                <div class="col-2" style="float:left">
                    {{parseFloat(permutacionprice).toFixed(2).replace(".",",") }}€
                </div>
            </div>
            <br/>
            <br/>
            <div class="col-12" v-if="unidades<maxunidades"> **Para pedidos de 1 solo neumático los gastos de envío son: {{gastos_envio}}€</div>
            <div class="col-12">*IVA incluido</div>
            <br/>
            <!-- <hr/> -->
             <!-- <div class="col-12">
                <div class="col-10">
                  <input type="checkbox" @click="calcularPrecioTotal(8,5)" name="pinchazos" id="pinchazos" value="8"><label for="montaje">Garantía antipinchazos </label>
                </div>
                <div class="col-2">
                    8 €
                </div>
            </div> -->
          </div>
          </tab-content>
          <tab-content title="IDENTIFICACIÓN" :before-change="validateBeforeSubmit">
            <div class="col-sm-12 ">
            <form @submit.prevent="" data-vv-scope="paso2">
              <div v-if="!is_logued_in" class="col-sm-12 ">
                  <label class="label">Email (obligatorio)</label>
                  <p class="control has-icon has-icon-right">
                      <input name="email" v-model="email" class="form-control" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('paso2.email') }" type="text">
                      <span v-show="errors.has('paso2.email')" class="alert alert-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                        <span class="help is-danger">{{ errors.first('paso2.email') }}</span>
                      </span>
                  </p>
              </div>
               <div v-if="!is_logued_in || !this.login_phone " class="col-sm-12">
                   <label class="label">Teléfono (obligatorio)</label>
                   <p class="control has-icon has-icon-right">
                       <input name="telefono" v-model="telefono"  data-vv-as="teléfono" class="form-control" v-validate="'required|numeric|min:9|max:10'" :class="{'input': true, 'is-danger': errors.has('paso2.telefono') }" type="text" >
                       <span v-show="errors.has('paso2.telefono')" class="alert alert-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                        <span class="help is-danger">{{ errors.first('paso2.telefono') }}</span>
                       </span>
                   </p>
               </div>
             <div v-if="!is_logued_in || !this.nombre" class="col-sm-12 ">
                 <label class="label">Nombre (obligatorio)</label>
                  <p>
                   <input name="nombre" v-model="nombre" type="text" class="form-control"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso2.nombre') }">
                      <span v-show="errors.has('paso2.nombre')" class="alert alert-danger">
                       <i class="fa fa-exclamation-triangle"></i>
                       <span class="help is-danger">{{ errors.first('paso2.nombre') }}</span>
                     </span>
               </p>
              </div>
            <div v-if="!is_logued_in || !this.dni" class="col-sm-12 ">
                <label class="label">Dni (obligatorio)</label>
                 <p>
                  <input name="dni" v-model="dni" type="text" class="form-control"  v-validate="'required|min:9|max:10'" :class="{'input': true, 'is-danger': errors.has('paso2.dni') }">
                     <span v-show="errors.has('paso2.dni')" class="alert alert-danger">
                      <i class="fa fa-exclamation-triangle"></i>
                      <span class="help is-danger">{{ errors.first('paso2.dni') }}</span>
                    </span>
              </p>
             </div>
              <div v-if="!is_logued_in || !this.direccion" class="col-sm-12 ">
                  <label class="label">Dirección (obligatorio)</label>
                   <p>
                    <input name="direccion" v-model="direccion" type="text" class="form-control"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso2.direccion') }">
                       <span v-show="errors.has('paso2.direccion')" class="alert alert-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                        <span class="help is-danger">{{ errors.first('paso2.direccion') }}</span>
                      </span>
                </p>
               </div>
               <div v-if="!is_logued_in || !this.codigo_postal" class="col-sm-12 ">
                   <label class="label">Código Postal (obligatorio)</label>
                    <p>
                     <input name="codigo_postal" v-model="codigo_postal" type="text" class="form-control"  v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('paso2.codigo_postal') }">
                        <span v-show="errors.has('paso2.codigo_postal')" class="alert alert-danger">
                         <i class="fa fa-exclamation-triangle"></i>
                         <span class="help is-danger">{{ errors.first('paso2.codigo_postal') }}</span>
                       </span>
                 </p>
                </div>
                <div class="col-sm-12">
                    <label class="label">Matrícula:</label>
                    <div class="control has-icon has-icon-right" style="padding-bottom:15px">
                      <input type="text" v-model="matricula" placeholder="" style="text-transform: uppercase;"/>
                      <div v-if="loading " class="loading-mini matricula-loader" >
                        <div v-if="!finished" class="loading" style="padding:0"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
                      </div>

                    </div>
                </div>
                <div class="col-sm-12">
                  <span v-show="matricula_status != ''" class="matricula_help alert " :class="{'alert-danger':!matricula_ok,'alert-success':matricula_ok}"><i v-show="!matricula_ok" class="fa fa-exclamation-triangle"></i><i v-show="matricula_ok" class="fa fa-check"></i>{{matricula_status}}</span>
                </div>
                <div class="col-sm-12 vehiculo" v-show="marca != ''">
                    <div class="">
                      <p><strong>Marca:</strong> {{marca}}</p>
                      <p><strong>Modelo:</strong> {{modelo}}</p>

                    </div>
                </div>
                <div class="col-sm-12">
                  <p class="control">
                <label class="checkbox">
                    <input name="terms"  v-validate="'required'" type="checkbox" data-vv-as="política de privacidad" style="width:15px;height:15px;float:left;">
                    <p>Acepto las <a href="https://delfingrupo.eu/condiciones-de-uso/" target="_blank">condiciones de uso</a>, <a href="/politica-privacidad" target="_blank">política de privacidad</a> y <a href="https://delfingrupo.eu/consentimiento-de-la-lopdgdd/" target="_blank">consentimiento de la ley de protección de datos</a>. </p>
                </label>
                <span v-show="errors.has('paso2.terms')" class="alert alert-danger">
                  <i class="fa fa-exclamation-triangle"></i>
                  <span class="help is-danger">{{ errors.first('paso2.terms') }}</span>
                </span>

            </p>
                </div>
            </form>
          </div>
          </tab-content>
          <!-- <tab-content title="ENTREGA" :before-change="validateBeforeSubmit2" @click=""> -->
          <tab-content title="ENTREGA" :before-change="validateBeforeSubmit2">
            <p><b>Selecciona uno de los 3 talleres más cercanos a tu dirección:</b></p>
            <div v-if="loading" class="loading" >
              <div class="loading" style="padding:0"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>
            </div>

            <form @submit.prevent="" data-vv-scope="paso3">
            <div v-if="mostrarTalleres==true">
                 <div v-for="(coordenada,key) in coordenadas" v-bind:key="key">
                      <input type="radio" name="taller" v-model="taller" v-bind:value="coordenada.id" :checked="checkedData == false" :class="{'input': true, 'is-danger': errors.has('paso3.taller') }" >
                       <b>Nombre: </b>{{coordenada.nombre}} - <b>Dirección: </b>{{coordenada.destino}} - {{coordenada.distancia.texto}} - {{ coordenada.duracion.texto}}
                  </div>
            </div>
            <br/>
            <div v-if="!is_logued_in || !this.codigo_postal" class="col-sm-12 ">
                <label class="label">Buscar Taller en otro Código Postal:</label>
                 <p>
                  <input name="codigo_postal2" v-model="codigo_postal2" type="text" class="form-control"  :class="{'input': true, 'is-danger': errors.has('paso3.codigo_postal2') }" >
                     <span v-show="errors.has('paso3.codigo_postal2')" class="alert alert-danger">
                      <i class="fa fa-exclamation-triangle"></i>
                      <span class="help is-danger">{{ errors.first('paso3.codigo_postal2') }}</span>
                    </span>
              </p>
             </div>
             <div class="col-sm-12">
               <span v-show="codigo_postal_status != ''" class="codigo_postal_help alert " :class="{'alert-danger':!codigo_postal_ok,'alert-success':codigo_postal_ok}"><i v-show="!codigo_postal_ok" class="fa fa-exclamation-triangle"></i><i v-show="codigo_postal_ok" class="fa fa-check"></i>{{codigo_postal_status}}</span>
             </div>
          </form>
          </tab-content>
          <!-- <tab-content title="PEDIDO" :before-change="beforeSelectTalleres" v-on:click=""> -->
          <tab-content title="PEDIDO" :before-change="beforeSelectTalleres" @click="pagoNeumaticos()">
            <div class="col-sm-12 pedido-desc">
            <div class="col-md-1 col-sm-2 col-2 imagen_ruedavent" style="float:left"><img :src="modalCompraShow.draw" onerror="this.src='https://intranet.dsimobility.es/images/servicios/neumaticos/neumatico_perfil.png'" width="50px !important"  height="50px !important" /></div>
            <div class="col-md-6 col-sm-5 col-5" style="float:left">{{modalCompraShow.brand}} {{modalCompraShow.model}} {{modalCompraShow.width}}/{{modalCompraShow.profile}} - {{modalCompraShow.diameter}}R {{modalCompraShow.load_rating}}{{modalCompraShow.speed_rating}}</div>
            <div class="col-md-3 col-sm-3 col-3" style="float:left">{{ unidades }} uds. </div>
            <div class="col-md-2 col-sm-2 col-2" style="float:left">x{{ importe }}€</div>

          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
                  <div class="col-sm-12"><div class="col-lg-7 col-md-7 col-sm-7 col-7" style="float:left"> Ecotasa:</div> <div class="col-md-3 col-sm-3 col-3" style="float:left"> {{ unidades }} uds.</div><div class="col-md-2 col-sm-2 col-2" style="float:left;text-align:center;">x{{ecotasa}}€</div><br/></div>
                  <div class="col-sm-12" v-if="precioseleccinado[1]==true" ><div class="col-md-7 col-sm-7 col-7" style="float:left">Kit Montaje: </div> <div class="col-md-3 col-sm-3 col-3" style="float:left"> {{ unidades }} uds.</div><div class="col-md-2 col-sm-2 col-2" style="float:left;text-align:center;">x{{montajeprice}}€</div><br/></div>
                  <!-- <div v-if="precioseleccinado[2]==true" style="margin-left:100px;">Pack seguridad: montaje+equilibrado+válvula (excluidas las electrónicas)+ nitrógeno+garantía antipinchazos  - 36,00€</div>-->
                  <div class="col-sm-12" v-if="precioseleccinado[3]==true"> <div class="col-md-7 col-sm-7 col-7" style="float:left">Alineación: </div> <div class="col-md-3 col-sm-3 col-3" style="float:left">&nbsp;</div><div class="col-md-2 col-sm-2 col-2" style="float:left;text-align:center;">{{alineacionprice}}€</div><br/></div>
                  <div class="col-sm-12" v-if="precioseleccinado[4]==true"><div class="col-md-7 col-sm-7 col-7" style="float:left">Permutación: </div> <div class="col-md-3 col-sm-3 col-3" style="float:left">&nbsp;</div><div class="col-md-2 col-sm-2 col-2" style="float:left;text-align:center;">{{permutacionprice}}€</div><br/></div>
                  <div class="col-sm-12" v-if="unidades<maxunidades"> <div class="col-md-7 col-sm-7 col-7" style="float:left">Gastos de envío: </div> <div class="col-md-3 col-sm-3 col-3" style="float:left">&nbsp;</div><div class="col-md-2 col-sm-2 col-2" style="float:left;text-align:center;">{{gastos_envio}}€</div><br/></div>
                  <!-- <div v-if="precioseleccinado[5]==true" style="margin-left:100px;">Garantía antipinchazos - 8,00€</div> -->
                  <div class="col-12">
                      <div class="col-md-10 col-sm-10 col-10" style="text-align:right;float:left"><b>Total:</b></div>
                      <div class="col-md-2 col-sm-2 col-2" style="float:left;text-align:center;"> <b>{{ preciototal }}€ </b> </div>
                  </div>
                  </div>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <br/>
                  <hr/>
                  <div><b>DATOS</b></div>
                  <div><b>DNI: </b>{{dni}}</div>
                  <div><b>Nombre: </b>{{nombre}}</div>
                  <div><b>Dirección: </b>{{direccion}}</div>
                  <div><b>Código Postal: </b>{{codigo_postal}}</div>
                  <br/>
                  <br/>
                  <hr/>
                  <div><b>TALLER SELECCIONADO PARA ENTREGA E INSTALACIÓN</b></div>

                  <div v-for="(coordenada,key) in coordenadas" v-bind:key="key">
                        <div v-if="coordenada.id==taller"><b>TALLER: </b>{{coordenada.nombre}} - {{coordenada.destino}}</div>
                  </div>
                  <br/>
                  <br/>
          </tab-content>
      </form-wizard>
      </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
        </div>
          <!-- </form-wizard> -->
        </div><!-- /.modal -->

     <div v-if="modalPagoShow">
     <div class="modal fade modal-pago show" tabindex="-1" role="dialog" style="display:block">
          <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                  <div class="modal-header">
                    <p>Pedido realizado.</p>
                      <button type="button" class="close" data-dismiss="modal" @click="modalPagoShow = false,modalCompraClose()"
                          aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  </div>
                  <div class="modal-body">
                      <p>En breve nos pondremos en contacto con usted y recibirá un correo con los datos del pedido.</p>
                  </div>
                </div><!--modal content-->
           </div>  <!-- modal dialog-->
            </div><!--modal Pago-->
         </div>
    </div>

</template>
<script src="https://unpkg.com/vue-router/dist/vue-router.js"></script>
<script type="text/javascript">
</script>
<script>
    var axios = require('axios');
    var qs = require('qs');
    // Load the full build.
    var _ = require('lodash');
    var debounce = require('lodash/debounce');

    export default {
        name: 'ListadoNeumaticos',
        data() {
            return {
                //link: "/dsimobility_principal",
                link:"",
                loading: false,
                isEditing: true,
                dataChanged: false,
                modalCompraShow: false,
                modalNeumaticoShow: false,
                mostrarTalleres:false,
                modalPagoShow:false,
                buscadorpaso2:false,
                buscadorpaso1:true,
                buscadorpaso3:false,
                checkedData:false,
                total: "",
                per_page: "",
                current_page: "",
                last_page: "",
                from: false,
                to: false,
                preciototal: "",
                importe:"",
                importenet:"",
                unidades: 1,
                dni: "",
                nombre: "",
                direccion:"",
                codigo_postal:"",
                codigo_postal2:"",
                codigo_postal_old:"",
                codigo_postal_status:"",
                codigo_postal_ok:false,
                telefono:"",
                email:"",
                cod_usuario:"",
                producto:"",
                productodesc:"",
                productomarca:"",
                productomodelo:"",
                montaje:"",
                alineacion:"",
                permutacion:"",
                montajeprice:"",//Precio del montaje
                alineacionprice:"",//Precio de la alineación
                permutacionprice:"",//Precio de la permutación
                diametro:"",
                ecotasa:"",
                ecotasatot:"",
                pedido:"",
                matricula: '',
                matricula_status: '',
                matricula_ok: false,
                marca: '',
                modelo: '',
                vin: '',
                makecode: '',
                umc: '',
                brand_normalized: '',
                precioseleccinado: [false, false, false, false, false, false],
                stock:"",
                margen:0.08,
                gastos_envio:4,
                gastos_producto:"",
                maxprecio:80,//Máximo precio sobre este precio se cobrarán gastos de envío
                maxunidades:2,
                selected_text: "selected",
                notSelected: "noSelected",
                request_filters: {
                    page: 1,
                    filters: {
                        ancho: 205,
                        tipo_vehiculo: 'NTURISMO',
                        estacion: 'VERANO',
                        marca: 0,
                        velocidad: 0,
                        carga: 0,
                        diametro: 16,
                        alto:55,
                        runflat: 'N',
                        reforzada: 'N'

                    },
                    orderBy: "id",
                    orderDir: "ASC",
                },
                selected: '1',
                coordenadas:'',
                taller: '',
                tallerDatos: '',
                datos_pago:'',
                tipovehiculos:'',
            }
        },
        created() {
            var that = this;
            //console.log(this.tipovehiculos);
            //console.log("Created");
            this.is_logued_in = this.logueado;
              },
        mounted() {
            this.getNeumaticos()

        },
         watch: {
                matricula: function (val) {
                    return this.comprobarMatricula();
                },
                codigo_postal2: function (val){
                    return this.comprobarCodigoPostal();
                }
        //     modal() {
        //         if (this.modalCompraShow) { // modal mostrada
        //             Vue.nextTick().then(() => this.$refs.nombre.focus());
        //         }
        //
        //     }
        //
         },
        methods: {
            async getNeumaticos() {
              window.scrollTo(0, 0);
              this.loading = true;
              var that = this;

                // Want to use async/await? Add the `async` keyword to your outer function/method.
                var filtros = this.request_filters.filters;
                var link = this.link;
                var datos =
                {

                'tipo_vehiculo' : filtros['tipo_vehiculo'],
                'estacion' : filtros['estacion'],
                'marca' : filtros['marca'],
                'ancho' : filtros['ancho'],
                'velocidad' : filtros['velocidad'],
                'diametro' : filtros['diametro'],
                'carga' : filtros['carga'],
                'runflat' : filtros['runflat'],
                'reforzada' : filtros['reforzada'],
                'perfil' : filtros['alto'],
                'pagina' : this.request_filters.page,
                'funcion_nombre' : 'obtenerListadoNeumaticos'
              };
              axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
                try {
                  /*console.log('llamando axios');
                    const response =  await axios.post('/api/v1.0', datos,{ crossdomain: true, headers: { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' }})
        .then(respuesta => {
                      console.log(respuesta.data);
                return respuesta.data
                })
                .then(data => {
                    this.$store.dispatch("guardarToken", data.token)
                    this.$router.push({ name: 'home' })
                });*/
                    //console.log(reponse);
                    var setHeader = {'Access-Control-Allow-Origin': '*'};
                    (function($) {
                      $.ajax({
                          async:false,
                          type: "POST",
                          //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/lib/solicitar_peticion.php',
                          //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/lib/solicitud.php',
                          url: link + '/wp-content/themes/Avada-Child-Theme/peticion/lib/neumaticos.php',
                          //url: link + '/lib/neumaticos.php',
                          data: { datos },
                          crossDomain: true,
                          dataType: 'json',
                          headers: setHeader,
                          success: function(response){
                            if(response.status == 200){
                              if(response.data.status == 200){
                                that.finished = true;
                                 that.loading = true;
                                 //console.log(this.loading);
                                 //this.$children["0"].maxStep = -1;
                                 that.total = response.data.datos.datos.data.total;
                                 that.per_page = response.data.datos.datos.data.per_page;
                                 that.last_page = response.data.datos.datos.data.last_page;
                                 that.current_page = response.data.datos.datos.data.current_page;
                                 that.from = response.data.datos.datos.data.from;
                                 that.to = response.data.datos.datos.data.to;
                                 that.list = response.data.datos.datos.data.data;
                                 that.tipovehiculos = response.data.datos.tipovehiculos;
                                 //console.log(response.data.datos.tipovehiculos);
                                 //console.log(this.tipovehiculos);
                                 that.marcas = response.data.datos.marcas;
                                 that.estaciones = response.data.datos.estaciones;
                                 that.anchuras = response.data.datos.anchuras;
                                 that.alturas = response.data.datos.alturas;
                                 that.velocidades = response.data.datos.velocidades;
                                 that.diametros = response.data.datos.diametros;
                                 that.cargas = response.data.datos.cargas;
                                 that.importenet = response.data.importe;
                                 that.preciototal = this.importe;
                                 that.loading = false;
                                 that.coordenadas='';
                                 that.loading = false;
                                 //console.log(this.tipovehiculos);
                               }
                              else{
                                console.log('Error');
                                for(var kk in response.data.msg){
                                  for(var kk2 in response.data.msg[kk]){
                                    this.errors.add(kk,response.data.msg[kk][kk2])
                                  }
                                }
                                this.loading = false;
                                this.mensaje_error= 'Revisa los errores para continuar';
                               }
                            }else{
                                this.loading = false;
                                this.mensaje_error= 'Error '+data.status;
                            }
                          },
                          error: function(error){
                            for( var err in error)
                            {
                              this.mensaje_error= 'Error'+err;
                              console.log(this.mensaje_error);
                            }
                          }
                        })
                      })(jQuery);
                    //console.log('Finish');

               } catch (error) {
                    console.log(error);
                    this.loading = false;
                }
            },
            setTipoPeticion: function (event) {
            },
            getPage: function (page) {
              //alert(page);
                this.request_filters.page = page;
                this.getNeumaticos();

            },
            calcularPrecio: function (importe) {
                if(this.montaje>0)
                {
                  this.montajeprice=12;
                  if(this.diametro>18)
                      this.montajeprice=15;
                  this.montaje=this.montajeprice*this.unidades;
                }
                this.ecotasatot=this.ecotasa*this.unidades;

                var precio=((((parseFloat(importe)+parseFloat(importe*this.margen))+(parseFloat(importe)+parseFloat(importe*this.margen))*0.21) * this.unidades)+this.montaje+this.alineacion+this.permutacion);
                var precio2 =parseFloat(precio)+parseFloat(this.ecotasatot);
                this.preciototal=parseFloat(precio2).toFixed(2);
                if(this.gastos_producto!='')
                {
                  this.gastos_producto='';
                }
                //alert(this.preciototal);

            },
            calcularPrecio2: function (importe, unidades) {
                this.preciototal = importe * unidades;
                this.preciototal.toFixed(2);

            },
            calcularPrecioUnidad:function(importe){
                var importenew=((parseFloat(importe)+parseFloat(importe*this.margen))+(parseFloat(importe)+parseFloat(importe*this.margen))*0.21).toFixed(2);
                return(importenew);
            },
            calcularPrecioTotal: function (importe, tipo, unidades) {
                var total=this.preciototal;
                unidades=this.unidades;

                if (this.precioseleccinado[tipo] == false) {
                    this.precioseleccinado[tipo] = true;

                    if(tipo==1){

                      this.montaje=parseFloat(importe*unidades);
                      this.preciototal = (parseFloat(total)+this.montaje).toFixed(2);
                    }
                    else if(tipo==3){
                      this.alineacion=parseFloat(importe);
                      this.preciototal = (parseFloat(total)+parseFloat(importe)).toFixed(2);
                    }else if(tipo==4){
                      this.permutacion=parseFloat(importe);
                      this.preciototal = (parseFloat(total)+parseFloat(importe)).toFixed(2);
                    }
                } else {
                    this.precioseleccinado[tipo] = false;

                    if(tipo==1){
                      this.montaje=0;
                      this.preciototal = (parseFloat(this.preciototal)-parseFloat(importe*unidades)).toFixed(2);

                    }
                    else if(tipo==3){
                      this.alineacion=0;
                      this.preciototal = (parseFloat(this.preciototal)-parseFloat(importe)).toFixed(2);
                    }else if(tipo==4){
                      this.permutacion=0;
                      this.preciototal = (parseFloat(this.preciototal)-parseFloat(importe)).toFixed(2);
                    }

                }

            },
            incrementTotal: function () {
                this.unidades += 1;

            },
            getUnidades: function (unidades, importe, producto,productodesc,productomarca,productomodelo,ecotax,diametro) {
                this.stock=0;
                this.unidades = unidades;
                this.preciototal = (((parseFloat(importe)+parseFloat(importe*this.margen))+(parseFloat(importe)+parseFloat(importe*this.margen))*0.21) * unidades).toFixed(2);
                this.producto = producto;
                this.productodesc=productodesc;
                this.productomarca=productomarca;
                this.productomodelo=productomodelo;
                this.ecotasa= parseFloat(ecotax);
                this.diametro=diametro;
                if(this.diametro>18)
                    this.montajeprice=15;
                else
                    this.montajeprice=12;
                this.alineacionprice=42;
                this.permutacionprice=10;
                if(this.gastos_producto!="")
                {
                    this.gastos_producto="";
                }
                this.preciototal = parseFloat(this.preciototal)+parseFloat(this.ecotasa*unidades);
                this.preciototal =this.preciototal.toFixed(2);
                this.importe= ((parseFloat(importe)+parseFloat(importe*this.margen))+(parseFloat(importe)+parseFloat(importe*this.margen))*0.21).toFixed(2);
                this.importenet=importe;

            },
            CalculaStock: function (){ //comprueba que hay stock suficiente y le suma al precio total calculado la Ecotasa
              var link = this.link;
              var that=this;
              if(this.stock>0)
                return true;

              var datos = {
                            cantidad: this.unidades,
                            producto: this.producto,
                            funcion_nombre: 'obtenerStockNeumaticos'
                          }

              /*axios.post('/neumaticos-stock',datos)
              .then((response) => {*/
              var setHeader = {'Access-Control-Allow-Origin': '*'};
              if(that.importe>0){
              (function($) {
                $.ajax({
                    async:false,
                    type: "POST",
                    //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/lib/solicitar_peticion.php',
                    //url: 'http://localhost/dsimobility/vuejs/prueba/src/components/lib/solicitud.php',
                    url: link + '/wp-content/themes/Avada-Child-Theme/peticion/lib/neumaticos.php',
                    data: { datos },
                    crossDomain: true,
                    dataType: 'json',
                    headers: setHeader,
                    success: function(response){

                      if(response.data==false)
                      {
                          that.stock=0;
                          alert("De este neumático no existe stock suficiente.")
                          //return false;

                      }else {
                          that.stock=1;
                          var importeold=that.importe;
                          var importenuevo=that.calcularPrecioUnidad(response.data.datos.Price);
                          if(importenuevo== that.importe)
                          {
                              that.$children["0"].nextTab();
                              that.setEstadistica(that.producto, 'compra-identificacion');
                          }
                          else{
                              if(response.data.Fee>0)
                                  that.ecotasa=response.data.datos.Fee;
                              that.importenet=response.data.datos.Price;

                              that.importe=importenuevo;
                              if(that.importe=="NaN")
                              {
                                that.importe=0;
                                that.preciototal=0;
                                that.unidades=0;
                                that.stock=0;
                                that.mensaje_error='Error al obtener el precio del producto. Inténtelo más tarde.';
                                alert("El proveedor ha variado el precio del producto y no se encuentra disponible en este momento, inténtelo más tarde");
                              }else{
                                that.getUnidades(that.unidades, response.data.Price, that.producto,that.productodesc,that.productomarca,that.productomodelo,that.ecotasa)
                                if(that.montaje>0)
                                  that.preciototal=parseFloat(that.preciototal)+parseFloat(that.montaje);
                                if(that.alineacion>0)
                                    that.preciototal=parseFloat(that.preciototal)+parseFloat(that.alineacion);
                                if(that.permutacion>0)
                                    that.preciototal=parseFloat(that.preciototal)+parseFloat(that.permutacion);
                                that.preciototal=parseFloat(that.preciototal).toFixed(2);
                                if(that.importe!="NaN")
                                  alert("El proveedor ha variado el precio del producto de "+importeold+"€ a "+that.importe+"€.\n\nSi acepta el nuevo precio continúe con la compra.")
                              }
                          }
                    }
                    return false;
                },
                error: function(error){
                  for( var err in error)
                  {
                    this.mensaje_error= 'Error'+err;
                    console.log(this.mensaje_error);
                  }
                }
              })
            })(jQuery);
              }
              /*})
              .catch((error)=> {
                this.stock=0;
                console.log(error.message);
              });*/
                return false;
            },
            setEstadistica: function(id, paso){
              var datos = {
                            id: id,
                            paso:paso
                          }
              /*axios.post('neumaticos-click',datos)
              .then((response) => {

              })
              .catch((error)=> {
                console.log(error.message);
              });*/
                return false;
            },
            cerrarModal: function(){
                modalCompraShow = false;
                //location.reload()
            },
            validateBeforeSubmit: function () {
                //alert("Aki dentro");
                this.mensaje_error = "";
                this.$validator.validateAll("paso2").then((result) => {
                    //alert(this.dni);
                    if (result) {
                        this.loading = true;
                        // // eslint-disable-next-line
                        var that = this;
                        var data = {
                            nombre: that.nombre,
                            direccion: that.direccion,
                            codigo_postal: that.codigo_postal,
                            dni: that.dni,
                            telefono: that.telefono,
                            email: that.email,
                            matricula:that.matricula,
                            marca:that.marca,
                            modelo:that.modelo
                        };
                        this.codigo_postal_old= that.codigo_postal;

                        if (that.is_logued_in) {
                            if (that.dni_activo) {
                                data["dni"] = that.dni;

                            }
                            if (that.nombre) {
                                data["nombre"] = that.nombre;
                            }
                            if (that.telefono) {
                                data["telefono"] = that.telefono;
                            }
                            if (that.email) {
                                data["email"] = that.email;
                            }
                        }

                        // handle file changes
                        var formData = new FormData();
                        // append the files to FormData
                        for (var k in data) {
                            formData.append(k, data[k]);

                        }
                        //Comprobar si la matricula es correcta
                        /*axios.post('/mobile/solicitar_peticion_matricula', formData, { crossdomain: true, headers: { 'Content-Type': 'multipart/form-data' }  } )
                        .then(function (response) {
                            if (response.status == 200){
                                if (response.data.success == true){
                                  that.finished = true;
                                  that.$children["0"].maxStep = -1;
                                }
                            else{
                              for(var kk in response.data.msg){

                                for(var kk2 in response.data.msg[kk]){
                                  that.errors.add(kk,response.data.msg[kk][kk2])
                                }

                              }
                              that.loading = false;
                              that.mensaje_error= 'Revisa los errores para continuar';
                            }
                          }
                          else{
                            that.loading = false;
                            that.mensaje_error = 'Error '+response.status;
                          }
                        })
                        .catch(function (error) {
                          that.loading = false;
                          that.mensaje_error = error.message;
                        });*/
                      //Registramos Usuario sino estuviera registrado previamente antes de pasar al siguiente paso
                      //const response=axios.get('/neumaticos-registroUsuarios?dni='+data["dni"]+'&nombre='+data["nombre"]+'&direccion='+data["direccion"]+'&cp='+data["codigo_postal"]+'&email='+data["email"]+'&telefono='+data["telefono"]).then((response) => {
                      var link = that.link;
                      var datos = {
                                    email: this.email,
                                    nombre: this.nombre,
                                    telefono: this.telefono,
                                    cp: this.codigo_postal,
                                    dni: this.dni,
                                    direccion:this.direccion,
                                    funcion_nombre: 'registrarUsuarioNeumaticos'
                                  }
                      var setHeader = {'Access-Control-Allow-Origin': '*'};
                      (function($) {
                        $.ajax({
                            async:false,
                            type: "POST",
                            url: link + '/wp-content/themes/Avada-Child-Theme/peticion/lib/neumaticos.php',
                            data: { datos },
                            crossDomain: true,
                            dataType: 'json',
                            headers: setHeader,
                            success: function(response){
                                that.cod_usuario=response.data.datos;
                            },
                            error:function(error){
                              for( var err in error)
                              {
                                this.mensaje_error= 'Error'+err;
                                console.log(this.mensaje_error);
                              }
                            }
                          })
                        })(jQuery);
                      /*  })
                        .catch((error) => {
                          console.log(error);
                        });*/
                        if(this.codigo_postal2!='')
                            this.obtainDistance2(data);
                        else
                            this.obtainDistance(data);
                        this.$nextTick(function() {
                          this.$children["0"].changeTab(1,2);
                          this.setEstadistica(this.producto, 'compra-entrega');
                        });

                        // if(this.gastos_producto!="")
                        // {
                        //   this.gastos_producto="";
                        //
                        // }
                        return true;
                    }
                });
            },
            validateBeforeSubmit2: function () {
                this.mensaje_error = "";
                if(this.codigo_postal2!="")
                {
                this.$validator.validateAll("paso3").then((result) => {
                    //alert(this.dni);
                    if (result) {

                        // // eslint-disable-next-line
                        var that = this;
                        var codigo_postal_old='';
                        if(that.codigo_postal2!="" && that.codigo_postal2!=that.codigo_postal_old)
                        {
                            var data = {
                                codigo_postal: that.codigo_postal2
                            };
                            this.codigo_postal_old=that.codigo_postal2;
                            // handle file changes
                            var formData = new FormData();
                            // append the files to FormData
                            for (var k in data) {
                                formData.append(k, data[k]);

                            }
                            //this.obtainDistance(data);
                         }
                         if(this.unidades<this.maxunidades && this.gastos_producto=="")
                          {
                            this.preciototal=parseFloat(this.preciototal)+parseFloat(this.gastos_envio);
                            this.gastos_producto=this.gastos_envio;
                          }
                          this.$children["0"].changeTab(2,3);
                          this.setEstadistica(this.producto,'compra-pedido');
                        }
                  });
              }else{
                  if(this.unidades<this.maxunidades && this.gastos_producto=="")
                  {
                    this.preciototal=parseFloat(this.preciototal)+parseFloat(this.gastos_envio);
                    this.gastos_producto=this.gastos_envio;
                  }
                  this.setEstadistica(this.producto,'compra-pedido');
                  return true;
              }
              return false;
            },
            validaMatricula: _.debounce(function(that){
              this.mensaje_error = "";
                    that.loading = true;
                    that.marca = '';
                    that.modelo = '';

                    /*axios.post('/mobile/obtener_modelo',{ matricula: that.matricula }, { crossdomain: true } )
                    .then(function (response) {

                      if(response.data.result == true){
                        that.loading = false;
                        that.marca = response.data.data.brand;
                        that.modelo = response.data.data.model;
                        that.matricula_status = "Matricula correcta";
                        that.matricula_ok = true;
                      }
                      else{
                        that.loading = false;

                        that.matricula_status = "No se pudo encontrar el modelo";
                        that.matricula_ok = true;

                      }
                      //  that.$children["0"].nextTab()
                    })
                    .catch(function (error) {
                      that.loading = false;
                      // Wu oh! Something went wrong
                      that.matricula_status = "Error al comprobar matricula";
                      that.matricula_ok = false;
                    });*/
                    (function($) {
                    $.ajax({
                        async:false,
                        type: "POST",
                        url: that.link+'/wp-content/themes/Avada-Child-Theme/peticion/lib/obtenerModelop.php',
                        data: { "matricula": that.matricula},
                        crossDomain: true,
                        dataType: 'json',
                        success: function(data){
                            if(data.result == true){
                              that.loading = false;
                              that.marca = data.data.data.brand;
                              that.modelo = data.data.data.model;
                              that.vin = data.data.data.vin;
                              that.makecode = data.data.data.makecode;
                              that.umc = data.data.data.umc;
                              that.brand_normalized = data.data.data.brand_normalized;
                              that.matricula_status = "Matricula correcta";
                              that.matricula_ok = true;
                            }
                            else{
                              that.loading = false;

                              that.matricula_status = "No se pudo encontrar el modelo";
                              that.matricula_ok = true;

                            }
                        }
                      })
                    })(jQuery);
                      return false;
              },1000),
              comprobarMatricula: function (event) {
                this.mensaje_error = "";
                var that =this;
                that.matricula_ok = false;

                this.matricula = this.matricula.toUpperCase();
                this.matricula = this.matricula.replace(/[^a-z0-9]/gi,'');
                if (that.matricula == ""){
                  that.matricula_status = 'Introduce tu matrícula';
                  that.matricula_ok = false;

                }
                else{

                  var expreg = /^(\d{4}[\D\w]{3}|[\D\w]{1,2}\d{4}[\D\\w]{1,2})$/;
                  if(expreg.test(that.matricula)){
                    that.matricula_status = "Comprobando matricula";
                    if (that.matricula_ok){
                      that.matricula_status = "Matricula correcta";
                      if (!that.primer_paso_validated){
                        return false;
                      }
                      else{
                        return true;
                      }

                    }

                    this.validaMatricula(that);

                  }
                  else{
                    that.matricula_ok = false;
                    that.loading = false;

                    that.matricula_status = "Formato de matrícula: 0000AAA ó A0000AA";
                    return false;
                  }

                }
              },
              comprobarCodigoPostal: function (event) {
                this.mensaje_error = "";
                var that =this;
                that.codigo_postal_ok = false;

                if (that.codigo_postal == ""){
                  that.codigo_postal_status = 'Introduce Código Postal';
                  that.codigo_postal_ok = false;
                }
                else{
                  var expreg = /^(\d{5})$/;
                  if(expreg.test(that.codigo_postal2)){
                    that.codigo_postal_status = "Comprobando Código Postal";
                    if (that.codigo_postal_ok){
                      that.codigo_postal_status = "Código Postal correcto";
                      if (!that.primer_paso_validated){
                        return false;
                      }
                      else{
                        return true;
                      }
                    }
                    that.obtainDistance2(that);
                    that.codigo_postal_ok=true;
                  }
                  else{
                    that.codigo_postal_ok = false;
                    that.loading = false;
                    that.codigo_postal_status = "Formato de Código Postal: 00000";
                    return false;
                  }

                }
              },
              modalNeumaticoClose(){
                  // var elements = document.getElementsByClassName('modal-backdrop');
                  // elements[0].parentNode.removeChild(elements[0]);
                  // document.body.className = document.body.className.replace("modal-open","");

            },
            modalCompraClose(){
                var elements = document.getElementsByClassName('modal-backdrop');
                elements[0].parentNode.removeChild(elements[0]);
                //console.log(elements);
                document.body.className = document.body.className.replace("modal-open","");

                this.montaje="";
                this.alineacion="";
                this.permutacion="";
                this.montajeprice="";//Precio del montaje
                this.alineacionprice="";//Precio de la alineación
                this.permutacionprice="";//Precio de la permutación
                this.preciototal= "";
                this.importe="";
                this.importenet="";
                this.unidades= 1;

                this.producto="";
                this.productodesc="";
                this.productomarca="";
                this.productomodelo="";
                this.ecotasa="";
                this.ecotasatot="";
                var tamanyo=this.precioseleccinado.length;
                for (var i=0;i<=tamanyo;i++){
                  this.precioseleccinado[i]=false;
                }
                this.modalCompraShow = false;
            },
            obtainDistance() {
              this.loading = true;
              this.mostrarTalleres=true;
              var destino='';
              var origen='';
              var link = this.link;
              var lat='';
              var lon='';
              var that = this;
              var datos = {
                      codigo_postal: that.codigo_postal,
                      direccion: that.direccion,
                      funcion_nombre: 'obtenerTalleresNeumaticos'
              };
             var setHeader = {'Access-Control-Allow-Origin': '*'};

            (function($) {
              $.ajax({
                  async:false,
                  type: "POST",
                  url: that.link + '/wp-content/themes/Avada-Child-Theme/peticion/lib/neumaticos.php',
                  data: { datos },
                  crossDomain: true,
                  dataType: 'json',
                  headers: setHeader,
                  success: function(response){
                    console.log(response);
                      var nombre_taller=response.data.nombre_taller;
                      var id_taller=response.data.id_taller;
                      var j=0;
                       that.coordenadas = [];
                       that.posicion = [];
                        var i=1;
                         for(var item of response.data.rows){
                           //console.log(item);
                            var j=0;
                            for (var elementos of item.elements){
                                //console.log(elementos.distance.text);
                              if(typeof elementos.distance !== 'undefined')
                              {
                                    that.coordenadas.push({
                                      distancia:{
                                          texto:elementos.distance.text,
                                          valor:parseFloat( elementos.distance.value)/1000,
                                        },
                                        duracion: {
                                            texto:elementos.duration.text,
                                            valor:parseFloat( elementos.duration.value),
                                        },
                                        origen: response.data.origin_addresses[i],
                                        destino: response.data.destination_addresses[j],
                                        nombre:  nombre_taller[j],
                                        id: id_taller[j]
                                      }
                                    );
                                    that.coordenadas=that.coordenadas.slice().sort(function(a, b) {
                                      return a.duracion.valor - b.duracion.valor;
                                    });
                             }
                              j++;
                            }
                             i++;
                             that.coordenadas.length=3;
                             that.taller = that.coordenadas[0].id;
                             that.loading=false;
                          }
                  },
                  error: function(error){
                    for( var err in error)
                    {
                      that.mensaje_error= 'Error'+err;
                      console.log(that.mensaje_error);
                    }
                  }
                });
            })(jQuery);
            },
            obtainDistance2() {
              this.loading = true;
              this.mostrarTalleres=true;
              var destino='';
              var origen='';
              var link = this.link;
              var that = this;
              var datos = {
                      codigo_postal: that.codigo_postal2,
                      direccion: '',
                      funcion_nombre: 'obtenerTalleresNeumaticos'
              };
             var setHeader = {'Access-Control-Allow-Origin': '*'};
            (function($) {
              $.ajax({
                  async:false,
                  type: "POST",
                  url: that.link + '/wp-content/themes/Avada-Child-Theme/peticion/lib/neumaticos.php',
                  data: { datos },
                  crossDomain: true,
                  dataType: 'json',
                  headers: setHeader,
                  success: function(response){
                      var nombre_taller=response.data.nombre_taller;
                      var id_taller=response.data.nombre_taller;
                      var j=0;
                       that.coordenadas = [];
                       that.posicion = [];
                        var i=1;
                         for(var item of response.data.rows){
                           //console.log(item);
                            var j=0;
                            for (var elementos of item.elements){
                                //console.log(elementos.distance.text);
                              if(typeof elementos.distance !== 'undefined')
                              {
                                    that.coordenadas.push({
                                      distancia:{
                                          texto:elementos.distance.text,
                                          valor:parseFloat( elementos.distance.value)/1000,
                                        },
                                        duracion: {
                                            texto:elementos.duration.text,
                                            valor:parseFloat( elementos.duration.value),
                                        },
                                        origen: response.data.origin_addresses[i],
                                        destino: response.data.destination_addresses[j],
                                        nombre:  nombre_taller[j],
                                        id: id_taller[j]
                                      }
                                    );
                                    that.coordenadas=that.coordenadas.slice().sort(function(a, b) {
                                      return a.duracion.valor - b.duracion.valor;
                                    });
                              }
                              j++;
                            }
                             i++;
                             that.coordenadas.length=3;
                             that.taller = that.coordenadas[0].id;
                             that.loading=false;
                          }
                  },
                  error: function(error){
                    for( var err in error)
                    {
                      that.mensaje_error= 'Error'+err;
                      console.log(that.mensaje_error);
                    }
                  }
                });
            })(jQuery);
            },
            beforeSelectTalleres: function(){
              this.$validator.validateAll("paso3").then((result) => {
                  //alert(this.nombre);
                  if (result) {
                      this.loading = true;
                      // // eslint-disable-next-line
                      var that = this;
                      var data = {
                          taller: that.id,
                          tallerDatos: that.nombre+' - '+that.direccion
                      };
                      this.setEstadistica(this.producto, 'compra-finalizar');
                      this.pagoNeumaticos();
                      this.loading = false;
                  }
                });
            },
            async pagoNeumaticos(){
              var datos=new Array();
              datos = {
                    usuario: this.cod_usuario,
                    dni: this.dni,
                    nombre:this.nombre,
                    direccion:this.direccion,
                    cp:this.codigo_postal,
                    telefono:this.telefono,
                    email:this.email,
                    taller: this.taller,
                    producto: this.producto,
                    preciounidad:this.importe,
                    unidades:this.unidades,
                    preciototal:this.preciototal,
                    descuento:0,
                    montaje:this.montaje,
                    alineacion:this.alineacion,
                    permutacion:this.permutacion,
                    pagado:0,
                    matricula:this.matricula,
                    marca:this.marca,
                    modelo:this.modelo,
                    vin:this.vin,
                    makecode:this.makecode,
                    umc:this.umc,
                    brand_normalized:this.brand_normalized,
                    productodesc:this.productodesc,
                    productomarca:this.productomarca,
                    productomodelo:this.productomodelo,
                    ecotasa:this.ecotasa,
                    viene_id_vector:1,
                    funcion_nombre: 'registroPedido'
                };
                var that=this;
               //const response=await axios.post('/neumaticos-registroPedido',datos);//.then((response) => {
                   //  this.pedido=response.data;
             var setHeader = {'Access-Control-Allow-Origin': '*'};
            (function($) {
              $.ajax({
                  async:false,
                  type: "POST",
                  url: that.link + '/wp-content/themes/Avada-Child-Theme/peticion/lib/neumaticos.php',
                  data: { datos },
                  crossDomain: true,
                  dataType: 'json',
                  headers: setHeader,
                  success: function(response){
                      that.pedido=response.data;
                  },
                  error: function(error){
                    for( var err in error)
                    {
                      that.mensaje_error= 'Error'+err;
                      console.log(that.mensaje_error);
                    }
                  }
                });
              })(jQuery);

              this.modalPagoShow=true;
              this.modalCompraShow=false;
              this.modalNeumaticoShow=false;
          },
          quitarClase(){
            $('.modal-neumatico').removeClass('show');
            $('.modal-neumatico').css('display','none');
            //$('.modal-neumatico').attr('aria-hidden','true');
          }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.devel{background-color:#f8f8f8 !important; }
.fusion-builder-column-0 {width: 100% !important;margin-top: 0px;margin-bottom: 20px;}
.fusion-layout-column {position: relative; float: left; margin-bottom: 20px;}
.lbel-buscador{font-size: 1em; font-family: Poppins;font-weight: 400;}
.fas.fa-question-circle p{visibility:hidden;margin-top:-40px;margin-left:50px;text-decoration:none;color:#000000;background:#ffffff;}
 a:hover .fas.fa-question-circle p{visibility:visible;text-decoration:none;}
 .listado-neumaticos input {
     color: #000;
     background: #fff;
     border: 0;
     box-shadow: 0 0 0 .1rem rgba(0,0,0,.1);
     padding: 10px 20px;

 }
 .listado-neumaticos input.col-1{
      padding-right:0px;
      padding-left:0px;
 }
 img.iconos{
   min-height:70px !important;
   min-width:70px !important;
 }
 .col-lg-1.sinimagen{
   float:left;
 }
 .col-md-1.sinimagen{
   float:left;
 }
 .col-sm-2.sinimagen{
   float:left;
  }
  .col-2.sinimagen{
    float:none;
  }
  @media only screen and (max-width: 500px) {
    #IDENTIFICACIÓN2 {
      margin-left:-30px;
    }
  }
  @media only screen and (max-width: 900px) {
  .col-12.montaje {
      height:100px;
    }
  }
  @media only screen and (max-width: 456px) {
  .col-12.montaje {
      height:140px;
    }
  }
  @media only screen and (max-width: 347px) {
  .col-12.montaje {
      height:160px;
    }
  }
  @media only screen and (max-width: 456px) {
  .col-12.ecotasa {
      height:30px;
    }
  }
  .neumaticos-titulo{
    height: auto;
    text-align:left;
  }
  @media only screen and (max-width: 848px) {
  .neumaticos-titulo{
      height:150px;
    }
  }
  @media only screen and (max-width: 767px) {
  .neumaticos-titulo{
      height:100px;
    }
  }
  .iconos{
    margin-top:0px;
  }
  /* .row.vehiculo{
    background-image: url("/images/servicios/neumaticos/medio_neumatico.png");
  } */
  /* .row.anchura{
     background-image: url("/images/servicios/neumaticos/medio_neumatico.png");
  } */
  .col-12.encabezado-neu{
    background-color:transparent;
  }
  .col-12.encabezado-neu2{
    background-color:#7993fc;
  }
  .col-12.encabezado-neu3{
    background-color:#7993fc;
  }
  .row-vehiculo .col-2{
      text-align:center;
  }
  .buscar_neu img{
    width:36px;
    height: 36px;
    min-height: 36px !important;
  }
.continuar_neu img{
  width:36px;
  height: 36px;
  min-height: 36px !important;
}
.col-12.cabecera-abajo3{
    position:absolute;
    margin-top:-5.5%;
}
.col-12.cabecera-abajo{
    position:absolute;
    margin-top:16%;
}
.col-md-12.col-sm-12.cabecera-abajo2{
    position:absolute;
    margin-top:-6%;
}
.cabecera-medidas{
   font-size:3em;
   font-weight:bold;
   text-align: center;

}
.titulo_oculto{
  position:absolute;
  top:10px;
  visibility: hidden;
}
@media only (min-width:1681px) and and (max-width: 1800px) {
  .col-12.abajo{
      position:absolute;
      bottom: 80px;
  }
}
@media screen and (min-width:1400px) and (max-width: 1540px) {
  .col-12.cabecera-abajo{
      float:left;
      position:absolute;
      margin-top:15%;
  }
}
@media screen and (max-width:1200px){
  .dvpaso1_ocultar{
    display: none;
  }
  .dvpaso1_mostrar{
    display: visible !important;
  }
  .col-md-10 .continuar_neu img{
      float:right !important;

  }
  .col-12.encabezado-neu-abajo .col-12 .col-md-3.col-sm-1 .col-md-10{
      float:right !important;
  }
  .col-12.encabezado-neu-abajo .col-12 .col-md-3.col-sm-1{
     padding-right:0px !important;
     padding-left:0px !important;
  }
  .col-12.encabezado-neu-abajo .col-12 .col-md-3.col-sm-1 .col-md-10{
     padding-right:0px !important;
     padding-left:0px !important;
  }

}
@media screen and (min-width:1100px) and (max-width: 1400px) {
  .col-12.cabecera-abajo{
      float:left;
      position:absolute;
      margin-top:14%;
  }
  .col-md-12.col-sm-12.cabecera-abajo2{
      position:absolute;
      margin-top:-6%;

  }
  .cabecera-medidas{
      font-size:2.5em !important;
  }
  .col-12.cabecera-abajo3{
      position:absolute;
      margin-top:-6%;
  }
}
@media screen and (min-width:900px) and (max-width: 1100px) {
  .col-12.cabecera-abajo{
      float:left;
      position:absolute;
      margin-top:13%;
  }
  .cabecera-medidas{
      font-size:2em !important;
  }
  .col-12.cabecera-abajo3{
      position:absolute;
      margin-top:-8%;
  }
}
@media screen and (min-width:900px) and (max-width: 991px) {
  .col-12.cabecera-abajo3{
      position:absolute;
      margin-top:-10%;
  }
}

  @media screen and (min-width:768px) and (max-width: 900px) {
    .col-12.cabecera-abajo{
        float:left;
        position:absolute;
        margin-top:12%;
    }
    .cabecera-medidas{
        font-size:1.8em !important;
    }
    .col-12.cabecera-abajo3{
        position:absolute;
        margin-top:-11%;
    }

  }
  @media screen and (min-width:576px) and (max-width: 767px) {

      .col-12.cabecera-abajo{
          float:left;
          position:relative;
          top:25px;
      }
      .texto_blanco{
        color:#000000 !important;

      }
      .cabecera-medidas{
          font-size:1.5em !important;
      }
      .encabezado-neu-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-6.col-10{
          text-align:left !important;
      }
      .encabezado-neu-abajo .col-12{
          top:-10px !important;
      }
      .encabezado-neu-abajo{
          height: 230px !important;
          background-color:#7993fc !important;
      }
      .cabecera-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-4.col-4{
          text-align:left !important;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-6.col-10{
          text-align:left !important;
      }
      .encabezado-neu2-abajo .col-12{
          top:-10px !important;
      }
      .encabezado-neu2-abajo{
          height: 230px !important;
          background-color:#7993fc !important;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-4.col-6{
          text-align:left !important;
          top:5px;
          left:0px !important;
      }
      .encabezado-neu2-abajo .col-xl-2.col-lg-2.col-md-2.col-sm-4.col-6{
        text-align:left !important;
        top:5px;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-2.col-sm-4.col-6{
          text-align:left !important;
          top:5px;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-2.col-sm-4.col-6{
          text-align:left !important;
          left:0px !important;
      }
      .col-12.cabecera-abajo3{
          position:absolute;
          margin-top:0%;
      }
      #antipichazos{
          color:#000000 !important;
          font-weight:normal !important;
      }
      #reforzados{
        color:#000000 !important;
        font-weight:normal !important;
      }
      .col-1.columna_oculta{
        display: none;
      }
  }

  @media screen and (max-width: 575px) {

    .titulo_oculto{
        position:absolute;
        top:10px;
        visibility:visible;
        font-size: 1.3em;
        font-weight: bold;
        text-align:center;
      }
      .encabezado-neu{
        background-image:none !important;
        /*background-color:#7993fc !important;*/
      }
      .encabezado-neu2{
        background-image:none !important;
        background-color:#7993fc !important;
      }
      .encabezado-neu3{
        background-image:none !important;
        background-color:#7993fc !important;
      }
    .encabezado-neu-abajo{
         height: 260px !important;
         background-color:#7993fc !important;
         margin-top:50px;
    }
      .encabezado-neu2-abajo{
        height: 230px !important;
        background-color:#7993fc !important;
      }
      .encabezado-neu3-abajo{
        height: 200px !important;
        background-color:#7993fc !important;
      }
      .cabecera-medidas{
          font-size:1.2em !important;
          text-align:center;
          margin-top:10px;
      }
      .col-12.cabecera-abajo{
          float:left;
          position:relative;
          top:25px;
          margin-left:-20px;
      }
      .texto_blanco{
        color:#000000 !important;
      }
      .encabezado-neu-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-6.col-10{
          text-align:left !important;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-6.col-10{
          text-align:left !important;
      }
      .encabezado-neu2-abajo .col-12{
          left:0px !important;
      }
      .encabezado-neu3-abajo .col-12{
          left:0px !important;
      }
      .encabezado-neu2-abajo .col-md-2.col-sm-1.col-1{
          left:10px !important;
      }
      .encabezado-neu2-abajo .col-md-8.col-sm-10.col-9.centrar{
        padding-right:0px !important;
        padding-left:0px !important;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-2.col-sm-4.col-6{
        text-align:center !important;
      }
      .encabezado-neu3-abajo .col-md-2.col-sm-1.col-1.centrar{
          left:10px !important;
      }
      .encabezado-neu3-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-6.col-10{
          text-align:left !important;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-4.col-6{
          text-align:center !important;
          left:0px !important;
      }
      .encabezado-neu2-abajo .col-xl-3.col-lg-3.col-md-2.col-sm-4.col-6{
          text-align:center !important;
          left:0px !important;
      }
      .encabezado-neu3-abajo .col-12{
          left:0px !important;
      }
      .encabezado-neu3-abajo .col-md-2.col-sm-1.col-1{
        padding-right:0px !important;
        padding-left:0px !important;

      }
      .col-12.cabecera-abajo3{
          position:absolute;
          margin-top:10px;
          margin-left:-20px;
      }
      #antipichazos{
          color:#000000 !important;
          font-weight:normal !important;
      }
      #reforzados{
        color:#000000 !important;
        font-weight:normal !important;
      }
      .cabecera-abajo .col-xl-3.col-lg-3.col-md-3.col-sm-4.col-4{
          text-align:left !important;
      }
      .col-1.columna_oculta{
        display: none;
      }
  }

  .encabezado-neu{
    display: flex;
    flex-direction: column;
    height: 900px;
    background: 50% no-repeat;
        background-image: none;
        background-color:#ffda7f;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 0 0;
  }
  .encabezado-neu2{
    display: flex;
    flex-direction: column;
    height: 300px;
    background: 50% no-repeat;
        background-image: none;
        background-color:#ffda7f;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 0 0;
  }
  .encabezado-neu3{
    display: flex;
    flex-direction: column;
    height: 300px;
    background: 50% no-repeat;
        background-image: none;
        background-color:#ffda7f;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 0 0;
  }
  .encabezado-neu-abajo{
    /* background-image: url("/images/servicios/neumaticos/cabecerapaso1_abajo.jpg");
    background-repeat:no-repeat;
    background-size: 100% !important;
      -webkit-background-size: 100% !important;
      -moz-background-size: 100% !important;
      -o-background-size: 100% !important;
    width:100%;
    height: auto;
     height: 0px;
    padding-top:7%; */
    display: flex;
    flex-wrap:wrap;
    background-color: rgba(255,255,255,.5);
    justify-content: center;
    align-self: stretch;
  }
  .encabezado-neu2-abajo{
    display: flex;
    flex-wrap:wrap;
    background-color: rgba(255,255,255,.5);
    justify-content: center;
    align-self: stretch;
  }
  .encabezado-neu3-abajo{
    display: flex;
    flex-wrap:wrap;
    background-color: rgba(255,255,255,.5);
    justify-content: center;
    align-self: stretch;
  }

/* .encabezado-neu3{
  background-image: url("/images/servicios/neumaticos/cabecerapaso3.jpg");
  background-repeat:no-repeat;
  width:100%;
  height: 0px;
  background-size: 100% !important;
    -webkit-background-size: 100% !important;
    -moz-background-size: 100% !important;
    -o-background-size: 100% !important;
  padding-top:26.5%
} */
.texto_blanco{
  color:#FFFFFF;
}
#antipichazos{
    color:#000000;
    /* font-weight : bold; */
}
#reforzados{
    color:#000000;
    /* font-weight : bold; */
}
.item-neumaticos{
  /* border: solid 1px #c3c3c3;
  border-radius: 5px;
  padding: 10px; */
  background-color: #fff;
  /* box-shadow: inset 0px 0px 5px 1px #cdcdcd; */
  margin-left: 0px;
  margin-right: 0px;
  margin-top:15px;
  margin-bottom:15px;
  margin-top: 20px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  display: flex;
  flex-wrap: wrap;
  }
  .neumaticos-titulo{
    font-weight: 600;
    font-size: 1.2em !important;
    line-height: 16px;
    margin-top: 0px !important;
    font-family: Poppins !important;
    color: #2F3042 !important;
  }
  .neumaticos-titulo a h3{
    /* font-size:1.1em !important; */
    font-size:0.8em !important;
    color: #2F3042 !important;
  }
  .neumaticos-titulo h4{
    font-size:0.8em !important;
    line-height: 0;
  }
  .col-precio{
    position:relative;
    float:left;
    padding-left:0px;
    padding-right:0px;
  }

  .cols-precio{
    min-height: 50px;
  }
  .boton-item-neumaticos {
    margin-bottom: 3px;
    background-color: #7993FC !important;
    padding: 5px;
    font-size: 0.6em;
    border: 2px #7993FC solid;
    border-radius: 5px;
    color: #fff !important;
    font-weight: bold;
    font-family: Poppins !important;
    box-shadow: 2px 2px 5px #d3dbe4 !important;
    width: 100%;
    text-align: center;
    bottom: 3px;
    position: relative;
    max-width:150px;
    float:right;
}
.precio-neumatico{
  font-size: 1.5em;
  color: #7993fc;
  padding-top: 20px;
}
.neumaticos-listado{
  background-color: transparent !important;
}
.precio-titulo-neumatico
{
  color:#c3c3c3;
}
.neumatico-info {
    background-color: #7993FC;
    width: 50%;
    text-align: center;
    display: flex;
    justify-content: center;
    margin: 0 auto;
}
.left {
    float: left;
    border-right: 10px dotted #ffffff;
    margin-top: 3px;
    margin-bottom: 3px;
}
.neumatico-info2 {
    width: 60%;
    text-align: left;
    display: flex;
    margin: 0 auto;
}
.neumatico-info2 .btn{
  background-color: #ffffff !important;
  margin-left: 5px !important;
  border-radius: 20px;
  padding: 10px 20px;
}
.neumatico-info2 .btn:visited{
  background-color: #7993FC !important;
  margin-left: 5px !important;
  border-radius: 20px;
  border-color:#fff;
  padding: 10px 20px;
}
.neumatico-info2 .btn:hover{
  background-color: #7993FC !important;
  margin-left: 5px !important;
  border-radius: 20px;
  border-color:#fff;
  padding: 10px 20px;
}
.neumatico-fondo {
    background-image: url("/images/servicios/neumaticos/fondo_vehi2.png");
    width: 80%;
    text-align: left;
    margin: 0 auto;
}
.neumatico-info3 {
    text-align: left;
    width: 60%;
    display: flex;
    margin-left: 40%;
}
.neumatico-info4 {
    text-align: right;
    width: 100%;
    position:relative;
    float:left;
    margin-top:30px;
}

.neu-precio {
    font-size: 3em;
    font-weight: bold;
    margin-top: 20px;
}
#IDENTIFICACIÓN2 {
  text-align:left;
}
.neumaticos-sombreado{
  box-shadow: 2px 2px 3px rgba(0,0,0,0.1);
  padding-top: 10px;
  border-top: 1px solid rgba(0,0,0,0.1);
  border-left: 1px solid rgba(0,0,0,0.1);
  background: #fff;
}
.producto-descripcion{
  font-size:0.7em;
  font-family: Poppins;
  font-weight:400;
  margin-top:20px;
}
.producto-descripcion a{
  color:#000000;
  text-decoration: underline;
}
#main .fusion-row{
  background-color:transparent !important;
}
.selects_en{
  width: 100%;
  font-family: Poppins;
  color: #495057;
  border-color: #bfbfbf;
}
.solicitarboton{
  margin-bottom: 3px;
  background-color: #7993fc !important;
  padding: 5px;
  font-size: .6em;
  border: 2px solid #7993fc;
  border-radius: 5px;
  color: #fff !important;
  font-weight: 700;
  font-family: Poppins !important;
  -webkit-box-shadow: 2px 2px 5px #d3dbe4 !important;
  box-shadow: 2px 2px 5px #d3dbe4 !important;
  width: 100%;
  text-align: center;
  bottom: 3px;
  position: relative;
}
.pagination{
  margin-left: 0px !important;
  margin-right: 0px !important;
  justify-content: center !important;
}
.page-link{
  background-color:transparent !important;
  color:#2f3042 !important;
  font-family: Poppins !important;
  border:0px !important;
}
.active .page-link{
  color:#7993fc !important;
}
.fade{
  opacity:1;
}
.modal-neumatico{
  margin-top:150px;
}
.modal-neumatico .modal-dialog{
  margin-top:220px;
}
.modal-compra{
  margin-top:150px;
}
.modal-compra .modal-dialog{
  margin-top:250px;
}
.modal-pago{
  margin-top:150px;
}
.modal-pago .modal-dialog{
  margin-top:250px;
}
.modal-header h2{
  color:#000;
  font-size:2em !important;
}
.modal-header .close{
  display:block;
  margin-top:-10px;
}
.vue-form-wizard .wizard-card-footer.clearfix{
  padding: 20px 20px !important;
}
.montaje{
  min-height: 50px;
}
.ecotasa{
  margin-top:20px;
}
@media only screen and (max-width: 999px) {
    .ofertas_imagen_principal img{
      width:70% !important;
    }
  }
  @media only screen and (max-width: 899px) {
    .ofertas_imagen_principal img{
      width:100% !important;
    }
  }
  @media only screen and (max-width: 767px) {
    .ofertas_imagen_principal img{
      width:50% !important;
    }
  }
  /*boton filtro neumaticos*/
#boton-filtro-neumaticos {
  display: none;
}
@media only screen and (max-width: 767px) {
  .vehiculo {
    display: none;
  }

  #boton-filtro-neumaticos {
    font-size: 14px;
    position: relative;
    float: right;
    display: block;
    top: -20px;
    width: 100px;
    height: 30px;
    text-align: center;
    color: #7993FC;
    padding-top: 2px;
  }

  #boton-filtro-neumaticos:hover {
    background: rgba(0, 0, 0, .6);
  }
}
@media only screen and (max-width: 500px) {
    .precio-neumatico{
      font-size:1.1em;
    }
  }
@media only screen and (max-width: 400px) {
    .neumatico-info2{
      width:90%;
    }
    .pedido-desc{
      padding-bottom:15px;
    }
}
@media only screen and (max-width: 991px) {
  .neumatico-info{
    width:90%;
  }
  .neumatico-fondo{
    width:90%;
  }
  .neu-precio{
    font-size: 1.3em;
  }
  .neumatico-info3{
    margin-left:0%;
    width:100%;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/ListadoNeumaticos.vue